import request from '@/utils/http.js'

// 获取sessionid
export const openSessionid = () => {
  return request({
    url: `/authority-center/open/sessionid`,
    method: 'get',
    headers: []
  })
}

// 获取图片验证码
export const openVerifyCode = (params) => {
  return request({
    url: `/authority-center/open/verify_code`,
    method: 'get',
    params
  })
}

// 用户名密码登录
export const openloginPcEnt = (params) => {
  return request({
    url: `/authority-center/open/login_pc_ent`,
    method: 'post',
    params
  })
}

// pc端手机验证码登录
export const opensmsloginPcEnt = (params) => {
  return request({
    url: `/authority-center/open/sms_login_pc_ent`,
    method: 'post',
    params
  })
}

// 重置密码
export const resetPwd = ({ newPassword, token }) => {
  return request({
    url: `/authority-center/common/resetpwd`,
    method: 'post',
    params: { newPassword },
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
}
